import React, { useEffect, useState } from 'react';
import HomeBlog from '../HomeBlog/HomeBlog';
import { Container } from 'react-bootstrap';
import './HomeBlogs.css'

const HomeBlogs = () => {
    const [homeBlogs, sethomeBlogs] = useState([]);
    const [limit, setLimit] = useState(3);

    useEffect(() => {
        fetch('/blog.json')
            .then(res => res.json())
            .then(data => sethomeBlogs(data))

    }, [])
    return (
        <div id="homeBlogs">
            <Container>
                <div className='services-dot'>
                    <h2>MY BLOGS</h2>
                    <h3>.</h3>
                </div>
                    <p className='serv-p p-2'>Click see more and watch my blog</p>
                <div className='home-blogs'>   
                    {
                        homeBlogs.slice(0, limit ? limit : homeBlogs.length).map(homeBlog => <HomeBlog
                            key={homeBlog._id}
                            homeBlog={homeBlog}
                            setLimit={setLimit}
                        >

                        </HomeBlog>)
                    }
                </div>
            </Container>
        </div>
    );
};

export default HomeBlogs;